const _umsUserEmail = (() => { const m = document.cookie.match(/(^| )umsUserEmail=([^;]+)/); return m ? m[2] : null; })();
const _umsCust = (() => { const m = document.cookie.match(/(^| )umsCust=([^;]+)/); return m ? m[2] : null; })();

const versionInfo = require("./version.json");
let pmode = versionInfo.pmode;
let cust = _umsCust ? _umsCust : (versionInfo.cust ? versionInfo.cust : "");
let custTenant = '';
var  url = window.location.href;
const hostname = new URL(url).hostname;

if (hostname.includes("multicom")) {
  custTenant = "multicom";
} else if (hostname.includes("sony")) {
  custTenant = "sony";
} else if (hostname.includes("growthday")) {
  custTenant = "growthday";
} else {
  custTenant = "cineverse";
}

let baseUrl = '';
let reportAPIBaseUrl = '';
let directBaseUrl = '';
let umsBaseUrl = '';
let umsBaseUrlV2 = (pmode === "live") ? 'https://api.cloud.junctiontv.net/jtvapi/7e2fd42a3db3426dd54d7f721e8cb71e/ums/v2/' : 'https://api.cloud.junctiontv.net/jtvapi/37e3049bd4938734e3720db9126011fb/ums/v2/';

if((cust && cust === 'multicom') || custTenant === "multicom" ) {

  baseUrl = "https://api.cloud.junctiontv.net/jtvapi/5dc383a3dda5052e4554955d7a06ee13/";
  reportAPIBaseUrl = "https://api.cloud.junctiontv.net/jtvapi/5dc383a3dda5052e4554955d7a06ee13/mpreport/insight/report/?pass=true";
  directBaseUrl = "http://multicom.insights.matchpoint.tv/";
  umsBaseUrl = "https://api.cloud.junctiontv.net/jtvapi/7f3cdca0e3a11fefa7d726c200bf41a3/ums/";
  
} else if((cust && cust === 'sony') || custTenant === "sony" ) {

  baseUrl = "https://api.cloud.junctiontv.net/jtvapi/206de653c97d5087ebccde470f52f5de/";
  reportAPIBaseUrl = "https://api.cloud.junctiontv.net/jtvapi/206de653c97d5087ebccde470f52f5de/mpreport/insight/report/?pass=true";
  directBaseUrl = "http://sony.insights.platform.matchpoint.tv/";
  umsBaseUrl = "https://api.cloud.junctiontv.net/jtvapi/206de653c97d5087ebccde470f52f5de/ums/";
  
} else if ((cust && cust === 'growthday') || custTenant === "growthday") {

  baseUrl = "https://api.cloud.junctiontv.net/jtvapi/d0fdbb7ce7f3696fd6b09ed33e2cc9ac/";
  reportAPIBaseUrl = "https://api.cloud.junctiontv.net/jtvapi/d0fdbb7ce7f3696fd6b09ed33e2cc9ac/mpreport/insight/report/?pass=true";
  directBaseUrl = "http://growthday.insights.platform.matchpoint.tv/";
  umsBaseUrl = "https://api.cloud.junctiontv.net/jtvapi/d0fdbb7ce7f3696fd6b09ed33e2cc9ac/ums/";

}
else {

  baseUrl = "https://api.cloud.junctiontv.net/jtvapi/6d54da5f7f5a5514076fdd7a348426b0/";
  reportAPIBaseUrl = "https://api.cloud.junctiontv.net/jtvapi/6d54da5f7f5a5514076fdd7a348426b0/mpreport/insight/report/?pass=true";
  directBaseUrl = "http://stage-insights.platform.matchpoint.tv/";
  umsBaseUrl = "https://api.cloud.junctiontv.net/jtvapi/7f3cdca0e3a11fefa7d726c200bf41a3/ums/";

  if (pmode === "live") { 
    umsBaseUrl = "https://api.cloud.junctiontv.net/jtvapi/78aca03eb1e870a6a366bdd7da5d0ce8/ums/";
  }

  if (pmode === "live") {
    baseUrl = "https://api.cloud.junctiontv.net/jtvapi/e68cc44e07430bb3c265e9c6b6f71413/";
    reportAPIBaseUrl = "https://api.cloud.junctiontv.net/jtvapi/e68cc44e07430bb3c265e9c6b6f71413/mpreport/insight/report/?pass=true";
    directBaseUrl = "http://insights.platform.matchpoint.tv/";

  }else if(pmode === "demo"){
    baseUrl = "https://api.cloud.junctiontv.net/jtvapi/9df85e161229caf829911fa29a7b0eb7/";
    reportAPIBaseUrl = "https://api.cloud.junctiontv.net/jtvapi/9df85e161229caf829911fa29a7b0eb7/mpreport/insight/report/?pass=true";
  }
}

export const ConURL = {
  ajaxBaseUrl: baseUrl,
  reportAPIBaseUrl: reportAPIBaseUrl,
  directBaseUrl:directBaseUrl,
  proxyPostUrl: "https://cloud.junctiontv.net/getfile.php?tag=",
  apiconsole: "https://api.cloud.junctiontv.net",
  umsBaseUrl: umsBaseUrlV2,

  ingestUrl: "ingestion/ingest/",
  summaryLog: "dashboard/event",
  fileLog: "dashboard/event/fileType",
  fileTypes: "dashboard/fileTypes",

  detailsbyFileId: "dashboard/event/file",
  detailsbyEventId: "dashboard/log/event",
  
  channelList: "mpingestion/ui/v1.0/channel",
  platformList: "mpingestion/ui/v1.0/platform",
  partnerList: "mpingestion/ui/v1.0/partner",
  digitalpartnerList: "mpingestion/ui/v1.0/digital-partner",
  licensorList: "mpingestion/ui/v1.0/licensor-service",
  sourceList: "mpingestion/ui/v1.0/partner-id-map/source",
  demandpartnerList: "mpingestion/ui/v1.0/demand-partner",
  amagiChannelMapList: "mpingestion/ui/v1.0/digital/channelMapping/ottAmagiChannelMapList",
  adChannelMapList: "mpingestion/ui/v1.0/digital/channelMapping/adChannelMapList",
  supplyRouterMapList: "mpingestion/ui/v1.0/supply-router-map",

  updateAmagiChannelMap: "mpingestion/ui/v1.0/digital/channelMapping/ottAmagiChannelMap/update",
  updateadChannelMap: "mpingestion/ui/v1.0/digital/channelMapping/adChannelMap/update",

  infoLog: "dashboard/info/fileType",
  calendarLog: "dashboard/event/calendar",

  licensorAbsent: "error/licensorAbsent",
  channelMap: "map/channel",
  amazonIdMap: "map/amazonId",
  absentInRightsline: "error/absentInRightsManager",

  loginUrl: "mpingestion/ui/v1.0/uauth/login",
  loginUMSUrl: "validate/token",
  reinviteUrl: "mpingestion/ui/v1.0/uauth/reinvite",
  activateUrl: "mpingestion/ui/v1.0/uauth/setPassword",
  userUrl: "mpingestion/ui/v1.0/user",
  forgotPasswordUrl: "mpingestion/ui/v1.0/uauth/forgotpassword",
  updatePasswordUrl: "mpingestion/ui/v1.0/uauth/updatePassword",

  linearChannelOverviewUrl: "mpreport/1.0/linear/get/channelstat",
  linearPlatformOverviewUrl: "mpreport/1.0/linear/get/platformstat",
  monthlyInsightsUrl: "mpreport/1.0/linear/get/last5monthstat",

  bestPerformerTitleUrl: "mpingestion/ui/v1.0/bestPerformer/topTitle",
  bestPerformerChannelUrl: "mpingestion/ui/v1.0/bestPerformer/top/channels",
  bestPerformerPartnerUrl: "mpingestion/ui/v1.0/bestPerformer/top/partners",
  bestPerformerPlatformUrl: "mpingestion/ui/v1.0/bestPerformer/top/platforms",
  bestPerformerLicensorUrl: "mpingestion/ui/v1.0/bestPerformer/top/licensors",
  topDirectorUrl: "mpingestion/ui/v1.0/bestPerformer/topCastCrew/director",
  topGenresUrl: "mpingestion/ui/v1.0/bestPerformer/topCastCrew/genres",
  topCastUrl: "mpingestion/ui/v1.0/bestPerformer/topCastCrew/cast",
  topProductionUrl: "mpingestion/ui/v1.0/bestPerformer/topCastCrew/production",
  bestPerformerTitleDownloadUrl: "mpingestion/ui/v1.0/bestPerformer/topTitle/csv",
  bestPerformerLicensorDownloadUrl: "mpingestion/ui/v1.0/bestPerformer/topLicensor/csv",
  bestPerformerCompareUrl:"mpingestion/ui/v1.0/bestPerformer/compare/topByMonth",
  bestPerformerDownloadCsvUrl:"mpingestion/ui/v1.0/bestPerformer/compare/topByMonthCsvDownload/",

  bestPerformerDigitalTitleUrl:"mpingestion/ui/v1.0/bestPerformer/top-title/digital",
  bestPerformerDigitalLicensorUrl:"mpingestion/ui/v1.0/bestPerformer/top-licensor/digital",
  bestPerformerDigitalCompareUrl:"mpingestion/ui/v1.0/bestPerformer/compare/top-by-month/digital",
  bestPerformerDigitalTitleDownloadUrl: "mpingestion/ui/v1.0/bestPerformer/top-title/digital/csv",
  bestPerformerDigitalLicensorDownloadUrl: "mpingestion/ui/v1.0/bestPerformer/top-licensor/digital/csv",

  reportAddIgnoredItemUrl: "mpingestion/ui/v1.0/ignored-item/add",
  reportAddToPartnerIDMapUrl: "mpingestion/ui/v1.0/partner-id-map/add",
  reportIgnoredItemListUrl: "mpingestion/ui/v1.0/ignored-item/list",
  reportActivateIgnoredItemUrl:
    "mpingestion/ui/v1.0/ignored-item/status/activate",
  reportDeactivateIgnoredItemUrl:
    "mpingestion/ui/v1.0/ignored-item/status/deactivate",
  accountingAddIgnoredItemUrl: "mpfinancereport/ui/v1.0/ignored-item/add/",
  accountingIgnoredItemListUrl: "mpfinancereport/ui/v1.0/ignored-item/list",
  accoutingActivateIgnoredItemUrl:
    "mpfinancereport/ui/v1.0/ignored-item/status/activate",
  accountingDeactivateIgnoredItemUrl:
    "mpfinancereport/ui/v1.0/ignored-item/status/deactivate",
  accountingGetIgnoredItemUrl : 'mpfinancereport/ui/v1.0/ignored-item/get/',

  reportListUrl: "mpingestion/ui/v1.0/inputFile/list",
  processAllReportUrl: "mpingestion/ui/v1.0/inputFile/finalprocess",
  processDownloadUrl: "mpingestion/ui/v1.0/inputFile/download/",
  reportRowListUrl: "mpingestion/ui/v1.0/inputFile/rowlist",
  uploadReportUrl: "mpingestion/ui/v1.0/inputFile/upload",
  processReportUrl: "mpingestion/ui/v1.0/inputFile/process",
  setAsErrorReportUrl: "mpingestion/ui/v1.0/inputFile/seterror",
  finalizeIngestReportUrl: "mpingestion/ui/v1.0/inputFile/finalize/",
  dailySingleMetricRowListUrl: "mpingestion/ui/v1.0/daily-metric/rowlist",
  automateReportUrl: "mpingestion/ui/v1.0/inputFile/fetch-monthly-frequency-report",

  dailyReportListUrl: "mpingestion/ui/v1.0/dailyInputFile/list",
  dailyReportRowListUrl: "mpingestion/ui/v1.0/dailyInputFile/rowlist",
  dailyInputFile: "mpingestion/ui/v1.0/dailyInputFile/upload",
  processDailyReportUrl: "mpingestion/ui/v1.0/dailyInputFile/process",
  setAsErrorDailyReportUrl: "mpingestion/ui/v1.0/dailyInputFile/seterror",
  dailyInputFileDownloadUrl: "mpingestion/ui/v1.0/dailyInputFile/download/",
  finalizeIngestDailyReportUrl : "mpingestion/ui/v1.0/dailyInputFile/finalize/",

  dailySubscriptionReportListUrl: "mpingestion/ui/v1.0/subscriptionInputFile/list",
  dailySubscriptionReportRowListUrl: "mpingestion/ui/v1.0/subscriptionInputFile/rowlist",
  dailySubscriptionReportInputFile: "mpingestion/ui/v1.0/subscriptionInputFile/upload",
  processDailySubscriptionReportUrl: "mpingestion/ui/v1.0/subscriptionInputFile/process",
  setAsErrorDailySubscriptionReportUrl: "mpingestion/ui/v1.0/subscriptionInputFile/seterror",
  dailySubscriptionReportInputFileDownloadUrl: "mpingestion/ui/v1.0/subscriptionInputFile/download/",
  finalizeIngestDailySubscriptioReportUrl :  "mpingestion/ui/v1.0/subscriptionInputFile/finalize/",

  dailySinglemetricReportListUrl:"mpingestion/ui/v1.0/daily-metric/get-all",
  dailySinglemetricReportRowListUrl:"mpingestion/ui/v1.0/daily-metric/rowlist",
  uploadSinglemetricReportUrl: "mpingestion/ui/v1.0/daily-metric/upload",
  dailySinglemetricInputFile: "mpingestion/ui/v1.0/daily-metric/process",
  dailySinglemetricReportUrl: "mpingestion/ui/v1.0/daily-metric/finalprocess",
  setAsErrorDailySinglemetricUrl: "mpingestion/ui/v1.0/daily-metric/seterror",
  dailySinglemetricInputFileDownloadUrl: "mpingestion/ui/v1.0/daily-metric/download/",

  dailyAdvertisementReportListUrl: "mpingestion/ui/v1.0/adInputFile/list",
  dailyAdvertisementReportRowListUrl: "mpingestion/ui/v1.0/adInputFile/rowlist",
  processDailyAdvertisementReportUrl: "mpingestion/ui/v1.0/adInputFile/process",
  setAsErrorDailyAdvertisementReportUrl: "mpingestion/ui/v1.0/adInputFile/seterror",
  dailyAdvertisementInputFileDownloadUrl: "mpingestion/ui/v1.0/adInputFile/download/",

  metricReportListUrl: "mpingestion/ui/v1.0/metric-file/list",
  metricReportRowListUrl: "mpingestion/ui/v1.0/metric-file/rowlist",
  uploadMetricReportUrl: "mpingestion/ui/v1.0/metric-file/upload",
  processMetricReportUrl: "mpingestion/ui/v1.0/metric-file/process",
  setAsErrorMetricReportUrl: "mpingestion/ui/v1.0/metric-file/seterror",
  processAllMetricReportUrl: "mpingestion/ui/v1.0/metric-file/finalprocess",
  processMetricReportDownloadUrl: "mpingestion/ui/v1.0/metric-file/download/",
  
  hourlyReportListUrl: "mpingestion/ui/v1.0/hourlyInputFile/list",
  hourlyReportRowListUrl: "mpingestion/ui/v1.0/hourlyInputFile/rowlist",
  hourlyInputFile: "mpingestion/ui/v1.0/hourlyInputFile/upload",
  processHourlyReportUrl: "mpingestion/ui/v1.0/hourlyInputFile/process",
  setAsErrorHourlyReportUrl: "mpingestion/ui/v1.0/hourlyInputFile/seterror",
  hourlyInputFileDownloadUrl: "mpingestion/ui/v1.0/hourlyInputFile/download/",
  finalizeIngestHourlyReportUrl : "mpingestion/ui/v1.0/hourlyInputFile/finalize/",

  contentWatchedReportListUrl: "mpingestion/ui/v1.0/firstcontentwatch/list",
  contentWatchedReportRowListUrl: "mpingestion/ui/v1.0/firstcontentwatch/rowlist",
  uploadContentWatchedReportUrl: "mpingestion/ui/v1.0/firstcontentwatch/upload",
  processContentWatchedReportUrl: "mpingestion/ui/v1.0/firstcontentwatch/process",
  setAsErrorContentWatchedReportUrl: "mpingestion/ui/v1.0/firstcontentwatch/seterror",
  processAllContentWatchedReportUrl: "mpingestion/ui/v1.0/firstcontentwatch/finalprocess",
  ContentWatchedReportInputFileDownloadUrl: "mpingestion/ui/v1.0/firstcontentwatch/download/",
  finalizeIngestContentWatchedReportUrl : "mpingestion/ui/v1.0/firstcontentwatch/finalize/",

  batchReportsListUrl : "mpingestion/ui/v1.0/awsmessages/list",

  revenueReportUrl:
    "mpingestion/ui/v1.0/report/monthlypartnerchannel/list/year-month",
  revenueUpdateUrl:
    "mpingestion/ui/v1.0/report/monthlypartnerchannel/updaterevenue/__ID__",
  quarterlyRevenueReportUrl:
    "mpingestion/ui/v1.0/report/quarterly-partner-channel/list/year-month",
  amazonIdMapUrl: "mpingestion/ui/v1.0/digital/channelMapping/amazonIdMap",
  amazonIDFilterUrl: "mpingestion/ui/v1.0/digital/config/catalogitem/__STRING__",
  amazonIdUpdateUrl: "mpingestion/ui/v1.0/digital/channelMapping/amazonIdMap/update",
  amazonIdUploadUrl: "mpingestion/ui/v1.0/digital/channelMapping/amazonIdMap/upload",
  amazonIdUploadListUrl: "mpingestion/ui/v1.0/digital/channelMapping/amazonIdMap/process/filelist",
  amazonIdDownloadUrl: "mpingestion/ui/v1.0/digital/channelMapping/amazonIdMap/download",

  partnerIdUpdateUrl:"mpingestion/ui/v1.0/partner-id-map/update",
  partnerIdMapUrl: "mpingestion/ui/v1.0/partner-id-map/list",  
  partnerIdMapDownloadUrl: "mpingestion/ui/v1.0/partner-id-map/download",
  partnerIdMapUploadUrl: "mpingestion/ui/v1.0/partner-id-map/upload",
  partnerIdMapHybridFileUploadUrl: "mpingestion/ui/v1.0/partner-id-map/file/records/upload",
  partnerIdMapUploadFileListUrl: "mpingestion/ui/v1.0/partner-id-map/process/filelist",
  
  LicensorAmountDueUploadUrl: "mpfinancereport/ui/v1.0/archive-file/upload",
  LicensorAmountDueListUrl: "mpfinancereport/ui/v1.0/archive-file/list",
  
  partnerOverviewUrl: "mpingestion/ui/v1.0/report/monthly/partnerStats/",
  platformOverviewUrl: "mpingestion/ui/v1.0/report/monthly/platformStats/",
  licensorOverviewUrl: "mpingestion/ui/v1.0/report/monthly/licensorStats/",
  deviceTypeOverviewUrl: "mpingestion/ui/v1.0/report/monthly/deviceStats/",
  reportIndiRowUrl: "mpingestion/ui/v1.0/reportIndiRow/list",
  reportIndiRowCSVUrl: "mpingestion/ui/v1.0/reportIndiRow/listCsv",
  reportIngestDetailsCSVUrl: "mpingestion/ui/v1.0/partner-id-map/file/records/download/",
  adOpsMothlyUrl:
    "mpingestion/ui/v1.0/digitalAdOpsMonthlyReport/list/__YEARMONTH__",
  accountingReportListUrl: "mpingestion/ui/v1.0/report/royalties/log/list", // to be removed
  accountingReportDownloadUrl: "mpingestion/ui/v1.0/report/royalties/download/",
  adOpsStatsUrl: "mpingestion/ui/v1.0/digitalAdOpsReport/",
  supplyRouterStatsUrl:"mpingestion/ui/v1.0/supplyRouterAdTagsReport/",
  royaltiesReportUrl: "mpingestion/ui/v1.0/report/royalties/list/", // to be removed
  licensorReportUrl: "mpingestion/ui/v1.0/report/royalties/group/licensor/", // to be removed

  licensorListUrl:
    "https://platform.matchpoint.tv/matchpoint/1.0/ui/catalogitem/licensorsList",
  scheduleReportUrl: "mpingestion/ui/v1.0/reportschedule/add",
  generateReportUrl: "mpingestion/ui/v1.0/reportgenerate/add",
  generateStatementUrl: "mpfinancereport/ui/v1.0/statement/add",
  scheduleReportListUrl: "mpingestion/ui/v1.0/reportschedule/list",
  generateReportListUrl: "mpingestion/ui/v1.0/reportgenerate/list",
  generateStatementListUrl: "mpfinancereport/ui/v1.0/statement/list",
  updatePaymentUrl: "mpfinancereport/ui/v1.0/statement/update-payment",
  scheduleFrequencyUrl: "mpingestion/ui/v1.0/reportfrequency",
  fetchMissingDataUrl: "mpingestion/ui/v1.0/reportgenerate/fetch-missing-data",

  deleteStatementUrl: "mpfinancereport/ui/v1.0/statement/",
  changeStateUrl: "mpfinancereport/ui/v1.0/statement/change-state",
  statementDownloadUrl: "mpfinancereport/ui/v1.0/statement/download/",
  statementDownloadArchiveUrl: "mpfinancereport/ui/v1.0/statement-row/download-archive/",
  generateReportDeleteUrl: "mpingestion/ui/v1.0/reportgenerate/report/",
  generateReportArchiveUrl: "mpingestion/ui/v1.0/reportgenerate/report/archive/",
  generateReportFinalizeUnfinalizeUrl: "mpingestion/ui/v1.0/reportgenerate/finalize/",
  schdlReportDeleteUrl: "mpingestion/ui/v1.0/reportschedule/report/",
  generateReportDownloadUrl: "mpingestion/ui/v1.0/reportgenerate/download/",
  generateReportDownloadLinkUrl: "mpingestion/ui/v1.0/reportgenerate/download-link/",
  generateStatementDetailUrl: "mpfinancereport/ui/v1.0/statement-row/search/",
  generateStatementReportUrl: "mpfinancereport/ui/v1.0/statement/generate/",
  generateStatementSummaryUrl: "mpfinancereport/ui/v1.0/statement/summary/",
  
  platformStatsYearlyUrl: "mpingestion/ui/v1.0/report/quarterly/ott/platformStats/yearly/",
  partnerStatsYearlyUrl: "mpingestion/ui/v1.0/report/quarterly/ott/partnerStats/yearly/",
  licensorStatsYearlyUrl: "mpingestion/ui/v1.0/report/quarterly/ott/licensorStats/yearly/",
  deviceTypeStatsYearlyUrl: "mpingestion/ui/v1.0/report/quarterly/ott/deviceStats/yearly/",  

  platformStatsQuarterlyUrl: "mpingestion/ui/v1.0/report/quarterly/ott/platformStats/",
  partnerstatsQuarterlyUrl: "mpingestion/ui/v1.0/report/quarterly/ott/partnerStats/",
  licensorstatsQuarterlyUrl: "mpingestion/ui/v1.0/report/quarterly/ott/licensorStats/",
  deviceTypestatsQuarterlyUrl: "mpingestion/ui/v1.0/report/quarterly/ott/deviceStats/",

  QuarterlyStatsUrl: "mpingestion/ui/v1.0/report/quarterly/ott/stats/",
  YearlyStatsUrl: "mpingestion/ui/v1.0/report/quarterly/ott/stats/yearly/",
  ConsolidatedUrl: "mpingestion/ui/v1.0/converge/report/monthly/",
  
  dailyOTTUrl:  "mpingestion/ui/v1.0/report/ott/daily/stats/",
  dailyOTTOverallUrl:  "mpingestion/ui/v1.0/report/ott/daily/overall/list/",

  digitalPartnerStatsMonthlyUrl :"mpingestion/ui/v1.0/digital/report/monthly/partnerStats/",
  digitalPlatformStatsMonthlyUrl :"mpingestion/ui/v1.0/digital/report/monthly/platformStats/",
  digitalLicensorStatsMonthlyUrl :"mpingestion/ui/v1.0/digital/report/monthly/licensorStats/",

  digitalDailyUrl : "mpingestion/ui/v1.0/dailyReport/performance/stats/",
  digitalDailyDetailUrl : "mpingestion/ui/v1.0/dailyReport/detailed-list/",

  platformStatsUrl: "mpingestion/ui/v1.0/digitalOttReport/monthly/platformstats",
  partnerstatsUrl: "mpingestion/ui/v1.0/digitalOttReport/monthly/partnerstats",
  channelstatsUrl: "mpingestion/ui/v1.0/digitalOttReport/monthly/channelstats",
  licensorstatsUrl: "mpingestion/ui/v1.0/digitalOttReport/monthly/licensorStats",
  deviceTypestatsUrl: "mpingestion/ui/v1.0/digitalOttReport/monthly/deviceStats",
  viewertypestatsUrl: "mpingestion/ui/v1.0/digitalOttReport/monthly/viewertypestats",
  monthlyViewerstatUrl: "mpingestion/ui/v1.0/digitalOttReport/monthlyViewerstat",
  monthlyAggregateUrl: "mpingestion/ui/v1.0/digitalOttReport/monthlyAggregate",
  monthlyOverAllAggregateUrl: "mpingestion/ui/v1.0/digitalOttReport/monthlyOverAllAggregate",

  licensorDetailsListUrl: "mpingestion/ui/v1.0/licensor/cinedigm/list",

  ottPartnerOverallStatsUrl: "mpingestion/ui/v1.0/report/overall/ott/partnerStats",
  ottPlatformOverallStatsUrl: "mpingestion/ui/v1.0/report/overall/ott/platformStats",
  ottLicensorOverallStatsUrl: "mpingestion/ui/v1.0/report/overall/ott/licensorStats",
  ottDeviceTypeOverallStatsUrl: "mpingestion/ui/v1.0/report/overall/ott/deviceStats",

  roleUrl: "mpingestion/ui/v1.0/role/",
  roleListUrl: "mpingestion/ui/v1.0/role/list",

  demandTagMapList    : "mpingestion/ui/v1.0/digital/channelMapping/demandTagMapList",
  demandTagMapgetById : "mpingestion/ui/v1.0/digital/channelMapping/demandTagMap/get",
  demandTagMapupdate  : "mpingestion/ui/v1.0/digital/channelMapping/demandTagMap/update",

  demandAdOpsMothlyUrl:
    "mpingestion/ui/v1.0/demandAdOpsMonthlyReport/list/__YEARMONTH__",
  demandAdOpsStatsUrl: "mpingestion/ui/v1.0/demandAdOpsReport/",

  emailTemplateUrl : "mpingestion/ui/v1.0/email-template",
  departmentUrl: "mpingestion/ui/v1.0/department",
  defaultDatesUrl:"mpingestion/ui/v1.0/latest-available-date/fetch-latest-available-date",

  cronjobtasksurl:"mpingestion/ui/v1.0/cronjobtask",
  cronjobstasksRunImmediately:"mpingestion/ui/v1.0/cronjobtask/runImmediately",
  cronjobtasksupdateStaterurl:"mpingestion/ui/v1.0/cronjobtask/updateState",

  cronjobschedulerurl:"mpingestion/ui/v1.0/cronjobscheduler",
  cronjobsschedulerscheduleImmediately:"mpingestion/ui/v1.0/cronjobscheduler/scheduleImmediately",
  cronjobschedulerupdateStaterurl:"mpingestion/ui/v1.0/cronjobscheduler/updateState",

  takeDownReportOTTMonthlyUrl:"mpingestion/ui/v1.0/report/monthly/takedown-report",
  takeDownReportDigitalMonthlyUrl:"mpingestion/ui/v1.0/digital/report/monthly/takedown-report",
  takeDownReportDigitalDailyUrl:"mpingestion/ui/v1.0/dailyReport/takedown-report",
  takeDownReportDigitalDownloadUrl:"mpingestion/ui/v1.0/digital/report/monthly/takedown-report/csv",
  takeDownReportOTTDownloadUrl:"mpingestion/ui/v1.0/report/monthly/takedown-report/csv",
  
  missingReportListUrl: "mpingestion/ui/v1.0/data-current-to/missing-list",

  bannerUrl : "mpingestion/ui/v1.0/banner/",
  dayPartingUrl : "mpingestion/ui/v1.0/dayParting/",
  adServerUrl : "mpingestion/ui/v1.0/adserver/sony/",

  reportTemplateListUrl : "mpingestion/ui/v1.0/reportgenerate/templates",
  reportTemplateSaveUrl : "mpingestion/ui/v1.0/reportgenerate/save-template",
  reportTemplateDeleteUrl : "mpingestion/ui/v1.0/reportgenerate/delete-template/",
  reportTemplateGenerateTimeParameterUrl : "mpingestion/ui/v1.0/reportgenerate/generateTimeParametersForTemplate/",
  
  ingestionFrequencyUrl : "mpingestion/ui/v1.0/monthDelay/delay/",
  ingestionFrequencyUpdateUrl : "mpingestion/ui/v1.0/monthDelay/delay/updateDelay",

  partnershipDashboardTopPerformerUrl : "mpingestion/ui/v1.0/partnerShip/top-performer/",
  ChannelPerformanceUrl : "mpingestion/ui/v1.0/partnerShip/channel-performance/stats/",
  ChannelPerformanceTooltipGraphUrl : "mpingestion/ui/v1.0/partnerShip/list/",
  BusinessMapDataUrl:"mpingestion/ui/v1.0/partnerShip/business-flow/",
  BusinessMapMetricUrl:"mpingestion/ui/v1.0/data-current-to/metric-availability",
  InDepthAnalyisUrl:
    "mpingestion/ui/v1.0/partnerShip/indepth-business-model/stats/",
  topProgramUrl : "mpingestion/ui/v1.0/programmingLeaderboard/top-programs/",
  periodicAnalysisUrl: "mpingestion/ui/v1.0/periodic/performance/",
  percentageOfMinutesViewed:"mpingestion/ui/v1.0/bestPerformer/percentMinutesViewed",
  firstContentWatchedListUrl:"mpingestion/ui/v1.0/firstcontentwatch/first-content-data-listing",
  customerLifetimeValue: "mpingestion/ui/v1.0/insights/customer-lifetime-value",
  seriesCompletionRateUrl: "mpingestion/ui/v1.0/completion-rate/fetch-series-completion-rate",
  settingsEpgScheduleUrl: "mpingestion/ui/v1.0/epg/cinedigm/list/",
  settingsFileUploadUrl: "mpingestion/ui/v1.0/file-upload/config/",
  settingsFileUploadRegionUrl: "mpingestion/ui/v1.0/file-upload/regions",
  ReportsFileUploadUrl: "mpingestion/ui/v1.0/reportgenerate/upload", 
  
  dms: {
      baseUrl: "http://ums.service.junctiontv.net",
      appUrl: "/dms/2.0/ui/appurls/",
      appUrlList: "http://dms.service.junctiontv.net/dms/2.0/app-loc-nc/appv-APPPPPP/APPXXXXXXX?version=__JTV__APP__VERSION__&devtype=__JTV__DEVICE__TYPE__&devcode=__JTV__DEVICE__CODE__&devnum=__JTV__DEVICE__NUM__",
      getIpInfo: "/util/geoip/info/"
  },
  console:"https://cloud.junctiontv.net",
};
